module.exports = __webpack_public_path__ + "static/media/lousa-4.062f764f.jpg";